import { render, staticRenderFns } from "./fail-rest.vue?vue&type=template&id=152057e3&"
import script from "./fail-rest.vue?vue&type=script&lang=js&"
export * from "./fail-rest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports